import { defineStore } from 'pinia'
import { socialService } from '@/services/socialService'

export const useSocialStore = defineStore('social', {
  state: () => ({
    pages: {},
    page: {},
    filter: {},
  }),

  actions: {
    async getPages() {
      try {
        const response = await socialService.fetchPages(this.filter);
        this.pages = response.data;
      } catch (error) {
        return;
      }
    },

    async getPage(id) {
      try {
        const response = await socialService.fetchPage(id);
        this.page = response.data;
      } catch (error) {
        return;
      }
    },

    async addPage(params) {
      
      try {
        await socialService.createPage(params);
        return { success: true };
      }
      catch (error) {
        if (error.response && error.response.status === 422) {
          return { success: false, errors: error.response.data.errors };
        }

        return { success: false, errors: {} };
      }
    },

    async updatePage(id, params) {
      
      try {
        await socialService.updatePage(id, params);
        return { success: true };
      }
      catch (error) {
        if (error.response && error.response.status === 422) {
          return { success: false, errors: error.response.data.errors };
        }

        return { success: false, errors: {} };
      }
    },
    
    
    async deletePage(id) {
      try {
        await socialService.deletePage(id);
        return { success: true };
      } catch (error) {
        return { success: false, errors: {} };
      }
    },
  }
});